// ============================================
// MAPPING: Types de biens selon transaction
// ============================================

export const TYPES_BIEN_BY_TRANSACTION = {
  "Vente": [
    "Fonds de commerce",
    "Licences", 
    "Murs commerciaux",
    "Locaux professionnels",
    "Bureaux",
    "Locaux industriels",
    "Droit au bail",
    "Terrains",
    "Investissement (en cours)"
  ],
  "Location": [
    "Locaux commerciaux (Location)",
    "Bureaux (Location)",
    "Locaux professionnels (Location)",
    "Locaux industriels (Location)",
    "Licences (Location)",
    "Autres locations"
  ]
};

// Mapping activités par type de bien
export const ACTIVITY_TYPES_BY_BIEN_TYPE_MAPPING = {
  "Fonds de commerce": [
    "Restaurant / Brasserie / Pizzeria / Snack / Fast-food",
    "Bar / Café / Pub / Lounge",
    "Boulangerie / Pâtisserie",
    "Épicerie / Supérette / Primeur",
    "Salon de coiffure / Institut de beauté / Spa",
    "Pharmacie / Parapharmacie",
    "Tabac / Presse / PMU",
    "Hôtel / Résidence hôtelière / Chambre d'hôtes",
    "Magasin de prêt-à-porter / Chaussures / Bijouterie",
    "Garage / Station-service / Centre auto",
    "Pressing / Blanchisserie",
    "Autres commerces (librairie, fleuriste, animalerie, etc.)"
  ],
  "Licences": [
    "Licence IV (débit de boissons)",
    "Licence III",
    "Licence restaurant",
    "Licence petite restauration",
    "Autres autorisations spécifiques (casino, tabac, etc.)"
  ],
  "Murs commerciaux": [
    "Libres",
    "Occupés (avec ou sans bail en cours)",
    "Murs loués avec rendement locatif"
  ],
  "Locaux professionnels": [
    "Libres",
    "Occupés",
    "En copropriété / indépendants",
    "Cabinets médicaux / paramédicaux",
    "Centres de soins / laboratoires",
    "Showrooms / locaux mixtes bureau + stockage"
  ],
  "Bureaux": [
    "Libres / occupés",
    "En open-space / cloisonnés",
    "Coworking / bureaux partagés",
    "Plateaux divisibles"
  ],
  "Locaux industriels": [
    "Libres / occupés",
    "Entrepôts / dépôts / hangars",
    "Ateliers de production / artisanaux",
    "Sites logistiques / plateformes de distribution"
  ],
  "Droit au bail": [
    "Tous types de commerces (restauration, retail, services, etc.)",
    "Bail commercial (3/6/9)",
    "Bail précaire",
    "Bail avec activité restreinte"
  ],
  "Terrains": [
    "Terrain industriel",
    "Terrain commercial",
    "Terrain artisanal",
    "Terrain constructible (zone d'activité)"
  ],
  "Investissement (en cours)": [
    "Immeubles mixtes (commerces + logements)",
    "Retail parks",
    "Centres commerciaux",
    "Actifs loués (murs + fonds ou ensemble locatif)"
  ],
  // Types Location - réutilisation des activités
  "Locaux commerciaux (Location)": [
    "Restaurant / Brasserie / Pizzeria / Snack / Fast-food",
    "Bar / Café / Pub / Lounge",
    "Boulangerie / Pâtisserie",
    "Épicerie / Supérette / Primeur",
    "Salon de coiffure / Institut de beauté / Spa",
    "Pharmacie / Parapharmacie",
    "Tabac / Presse / PMU",
    "Hôtel / Résidence hôtelière / Chambre d'hôtes",
    "Magasin de prêt-à-porter / Chaussures / Bijouterie",
    "Garage / Station-service / Centre auto",
    "Pressing / Blanchisserie",
    "Autres commerces (librairie, fleuriste, animalerie, etc.)"
  ],
  "Bureaux (Location)": [
    "Libres / occupés",
    "En open-space / cloisonnés",
    "Coworking / bureaux partagés",
    "Plateaux divisibles"
  ],
  "Locaux professionnels (Location)": [
    "Libres",
    "Occupés",
    "En copropriété / indépendants",
    "Cabinets médicaux / paramédicaux",
    "Centres de soins / laboratoires",
    "Showrooms / locaux mixtes bureau + stockage"
  ],
  "Locaux industriels (Location)": [
    "Libres / occupés",
    "Entrepôts / dépôts / hangars",
    "Ateliers de production / artisanaux",
    "Sites logistiques / plateformes de distribution"
  ],
  "Licences (Location)": [
    "Licence IV (débit de boissons)",
    "Licence III",
    "Licence restaurant",
    "Licence petite restauration",
    "Autres autorisations spécifiques"
  ],
  "Autres locations": [
    "À définir"
  ]
};
